import { Component } from '@angular/core';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { DeviceService } from 'src/app/services/device.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetailDTO } from 'src/app/models/DeviceDetailDTO.model';
import { DataInputPlanDevices } from 'src/app/models/DataInputPlanDevices.model';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { saveAs } from 'file-saver';
import { PaginationService } from 'src/app/shared/services/pagination.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DoubleScrollComponent } from '../../../shared/components/double-scroll/double-scroll.component';
import { SearchPipe } from '../../../pipes/search.pipe';
@Component({
    selector: 'app-list-devices',
    templateUrl: './list-devices.component.html',
    styleUrls: ['./list-devices.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        DoubleScrollComponent,
        SearchPipe
    ]
})
export class ListDevicesComponent {
  devices: DeviceDetailDTO[] = [];
  filteredDevices: DeviceDetailDTO[] = [];
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userNames',
    'planName',
    'iccid',
    'imei',
    'devName',
    'consumption',
  ];
  isFilteredByStatus: boolean = false;
  originalDevices: any[] = [];
  selectedDevice: any;
  dataInputPlanDevices: DataInputPlanDevices = {} as DataInputPlanDevices;
  alert: Alert = {} as Alert;

  constructor(
    private deviceService: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    public paginationService: PaginationService
  ) { }

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Customers);   // ToDo: ?????  это ошибка? может быть Devices?
    this.deviceService.getListDevices().subscribe(
      ({ StatusCode, Message, Data }) => {
        
        if (Data != null) {
          this.HandleGetListDevices(Data);
        } else {
          this.HandleGetListDevicesError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  onSearchChange(): void {
    this.paginationService.currentPage = 1;
    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );
  }


  HandleGetListDevices(device: DeviceDetailDTO[]) {
    
    this.devices = device;
    this.originalDevices = this.devices.slice();
    this.devices = this.originalDevices.filter(
      (user) => user.deviceStatus === 0 || user.deviceStatus === 1
    );

    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );

    // Reinicia la paginación a la primera página
    this.paginationService.currentPage = 1;
  }

  HandleGetListDevicesError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.devices = this.originalDevices.slice(); // Restaura la lista original
    this.devices = this.devices.filter(
      (user) => user.deviceStatus === 0 || user.deviceStatus === 1
    );
    
    this.paginationService.currentPage = 1;
    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );
  }

  filterByStatus(status: number) {
    this.devices = this.originalDevices.slice(); // Restaura la lista original
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalDevices = this.devices.slice();
      this.isFilteredByStatus = true;
    }

    this.devices = this.originalDevices.filter(
      (device) => device.deviceStatus === status
    );
    
    this.paginationService.currentPage = 1;
    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );
  }

  redirectToCustomer(device: DeviceDetailDTO) {
    let customer = {
      userId: device.userId,
    };
    this.router.navigate(['/customers/customer-plans'], {
      relativeTo: this.route,
      state: { customerData: customer },
    });
  }

  redirectToDevice(device: any) {
    
    this.dataInputPlanDevices.customerId = device.userId;
    this.dataInputPlanDevices.customerName = device.userNames;
    this.dataInputPlanDevices.planID = device.userPlanId;
    this.dataInputPlanDevices.planName = device.planName;

    //console.log(this.dataInputPlanDevices);

    this.router.navigate(['/customers/plan-devices'], {
      relativeTo: this.route,
      state: { dataInputPlanDevice: this.dataInputPlanDevices },
    });

    // console.log('Redirecting to device:', device.iccid);
  }

  get pages(): number[] {
    return this.paginationService.pages;
  }

  changePage(page: number) {
    this.paginationService.changePage(page);
    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );
  }

  previousPage() {
    this.paginationService.previousPage();
    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );
  }

  nextPage() {
    this.paginationService.nextPage(this.filteredDevices.length);
    this.filteredDevices = this.paginationService.updatePagination(
      this.devices, this.textoBusqueda, this.camposBusqueda
    );
  }

  getRange(): string {
    return this.paginationService.getRange(this.filteredDevices.length);
  }

  exportListDevicesToExcel() {
    this.deviceService.exportToExcelListDevices().subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetFileError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetFileError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }
}
